import { useState, useEffect } from "react";
import { Link } from "react-router-dom"
import PropTypes from "prop-types"
import { Box, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Flex, Image, Heading, Stack, Text } from "@chakra-ui/react"
import good_hands from '../assets/images/youre_in_good_hands.jpg'
import integrity01 from '../assets/images/integrity01.png'
import community01 from '../assets/images/community01.png'
import environmental01 from '../assets/images/environmental01.png'
import safety01 from '../assets/images/safety01.png'
import integrity02 from '../assets/images/integrity02.png'
import community02 from '../assets/images/community02.png'
import environmental02 from '../assets/images/environmental02.png'
import safety02 from '../assets/images/safety02.png'
import divider from '../assets/images/icon.png'
import partners from '../assets/images/partners.jpg'
import { useLanguage } from "./LanguageContext"

export default function MainPage(props) {
  const { language } = useLanguage();
  const isEnglish = language === "en";

  const {
    title,
    subtitle,
    image,
    ctaText,
    ctaLink,
    ...rest
  } = props;

  //const MainPage = ({ title, subtitle, image, ctaLink, ctaText, ...rest }) => {
  const [isOpen, setIsOpen] = useState(true); // Modal opens by default

  const handleAgree = () => {
    setIsOpen(false); // Close modal when user agrees
    localStorage.setItem("agreedToTOS", "true"); // Store agreement
  };

  useEffect(() => {
    // Check if user has already agreed
    const agreed = localStorage.getItem("agreedToTOS");
    if (agreed) {
      setIsOpen(false);
    }
  }, []);

  const finalTitle = title ?? (isEnglish ? "Welcome to BALGOD" : "Bienvenido a BALGOD");
  const finalSubtitle = subtitle ?? (isEnglish ? "a christian fund, for future investments!" : "un fondo cristiano, para futuras inversiones!");
  const finalImage = image ?? good_hands;
  const finalCtaText = ctaText ?? (isEnglish ? "Create your account now" : "Crea tu cuenta ahora");
  const finalCtaLink = ctaLink ?? "/signup/create-account";

  return (
    <>

    {/* Pop-up Modal */}
    <Modal isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Terms of Service Agreement</ModalHeader>
          <ModalBody>
            <Text>You must agree to the Terms of Service to use this website.</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleAgree}>I Agree</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>


      <Flex
        align="center"
        justify={{ base: "space-evenly", lg: "space-around", xl: "space-between" }}
        direction={{ base: "column-reverse", lg: "row" }}
        wrap="no-wrap"
        minH="70vh"
        px={8}
        mt={12}
        // mt={{base:"0", lg:"8"}}
        mb={16}
        {...rest}
      >
        <Stack
          spacing={4}
          w={{ base: "80%", lg: "40%" }}
          align={["center", "center", "center", "center"]}
        >
          <Heading
            as="h1"
            size={{ base: "lg", lg: "xl" }}
            fontWeight="bold"
            color="primary.800"
            textAlign={["center", "center", "center", "center"]}
          >
            {finalTitle}
          </Heading>
          <Heading
            as="h2"
            size={{ base: "sm", lg: "md" }}
            color="primary.800"
            opacity="0.8"
            fontWeight="normal"
            lineHeight={1.5}
            textAlign={["center", "center", "left", "left"]}
          >
            {finalSubtitle}
          </Heading>
          <Link to={finalCtaLink}>
            <Button
              color="white"
              bgColor="black"
              borderRadius="8px"
              mt="6"
              py="4"
              px="4"
              lineHeight="1"
              size="md"
            >
              {finalCtaText}
            </Button>
          </Link>
        </Stack>
        <Box w={{ base: "100%", lg: "60%" }} mb={{ base: 12, lg: 0 }}>
          <Image src={finalImage} size="100%" rounded="1rem" shadow="2xl" />
        </Box>
      </Flex>


      <Flex
        w="100%"
        justify="center"
        mt={8}
        px={8}
        backgroundColor="cyan.50"
      >
        <Box
          w="100%"
          maxW="90%"
          flex="1"
          p={4}
          mx={0}
          textAlign="center"
          fontSize={{ base: 24, lg: 40 }}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Text mb={14}>
            {isEnglish ? "Discover What Makes Us Different" : "Descubre Lo Que Nos Hace Differentes"}
          </Text>
          <Image src={divider} width="50px" />
          <Text fontSize={{ base: 18, lg: 20 }} color={"#444"} lineHeight={"2.0"} mt={5} textAlign="justify">
            {isEnglish ? (
              <>
              At <b>BALGOD</b>, we are committed to transforming the mining sector by eliminating intermediaries and 
              establishing direct, mutually beneficial partnerships with Mine Owners. Founded in 2023, <b>BALGOD</b> was 
              built upon a collective vision shared by a diverse team of experts—ranging from mining and fusion 
              process specialists to economists, international security experts, and global sales professionals—who 
              have come together with a singular purpose: to bring fairness, transparency, and efficiency to the 
              mining industry. The name Balance of God symbolizes our guiding principle of fostering harmony and 
              ethical business practices across the entire supply chain.<br/><br/>
              </>
            ):(
              <>
              En <b>BALGOD</b>, nos comprometemos a transformar el sector minero eliminando a los intermediarios y 
              estableciendo asociaciones directas y mutuamente beneficiosas con los propietarios de minas. Fundada en 
              2023, <b>BALGOD</b> nació de una visión compartida por un equipo diverso de expertos—que van desde especialistas 
              en minería y procesos de fusión hasta economistas, expertos en seguridad internacional y profesionales de 
              ventas globales—quienes se unieron con un único propósito: aportar justicia, transparencia y eficiencia a 
              la industria minera. El nombre Balance of God, Balance de Dios, simboliza nuestro principio rector de 
              fomentar la armonía y prácticas empresariales éticas a lo largo de toda la cadena de suministro.<br/><br/>
              </>
            )}
          </Text>
        </Box>

      </Flex>

      <Flex
        w="100%"
        justify="center"
        alignItems="center"
        wrap="wrap"
        pt={14}
        px={8}
        pb={14}
        direction={{ base: "column", lg: "row" }}
        backgroundColor="cyan.50"
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          p={4}
          mx={{ base: 0, md: 2 }}
          textAlign="center"
          mb={{ base: 0, lg: 14 }}
          w={{ base: "100%", lg: "80%" }}
          maxWidth="900px"
          backgroundColor={"black"}
        >
          <iframe
            style={{
              width: "100%",
              height: "auto",
              aspectRatio: "16/9",
              maxWidth: "100%",
              border: "none"
            }}
            src="https://www.youtube.com/embed/WU0a0ZNAZnc?si=lRitG9VuIq7ot3GG"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </Box>
        </Flex>

      <Flex
        w="100%"
        justify="space-around"
        wrap="wrap"
        px={8}
        pt={10}
        pb={10}
        direction={{ base: "column", lg: "row" }}
        backgroundColor="black" // Set the background color to black for the whole Flex container
      >
        <Box w="100%" maxW="90%" flex="1" p={4} mx={0} textAlign="center">
        <Text mb={14} color={"white"} fontSize={{ base: 24, lg: 35 }}>
          {isEnglish ? "Our Vision" : "Nuestra Visión"}
          </Text>
          <Text fontSize={{ base: 18, lg: 20 }} color={"white"} lineHeight={"2.0"} textAlign="justify">
            {isEnglish ? (
              <>
              Our vision at <b>BALGOD</b> is clear: to create an
              innovative, fair, and sustainable mining model that eliminates the need for brokers and intermediaries. By 
              establishing direct, trusted relationships with mine owners and partners, we aim to streamline operations 
              and optimize the flow of precious minerals—such as gold, silver, rhodium, and palladium—from mine to market. 
              Our commitment to this vision extends beyond financial success; we aspire to build a legacy of responsible 
              business practices that will endure for generations, benefiting not only our partners and employees but 
              also the global communities that rely on these resources.<br/><br/>
              </>
            ):(
              <>
              Nuestra visión en <b>BALGOD</b> es clara: crear un modelo minero innovador, justo y sostenible que elimine la 
              necesidad de corredores y intermediarios. Al establecer relaciones directas y confiables con los propietarios 
              de minas y nuestros socios, buscamos agilizar las operaciones y optimizar el flujo de minerales preciosos—como 
              oro, plata, rodio y paladio—desde la mina hasta el mercado. Nuestro compromiso con esta visión va más allá 
              del éxito financiero; aspiramos a construir un legado de prácticas empresariales responsables que perduren por 
              generaciones, beneficiando no solo a nuestros socios y empleados, sino también a las comunidades globales que 
              dependen de estos recursos.<br/><br/>
              </>
            )}
          </Text>
             <Text mb={14} color={"white"} fontSize={{ base: 24, lg: 35 }}>
              {isEnglish ? "Our Mission" : "Nuestra Misión"}
              </Text>
             <Text fontSize={{ base: 18, lg: 20 }} color={"white"} lineHeight={"2.0"} textAlign="justify">
              {isEnglish ? (
                <>
                At <b>BALGOD</b>, we are driven 
                by a strong sense of responsibility toward our partners, our employees, and the environment. Our mission 
                is to create a financial family—a united and supportive network of members and partners who will thrive 
                together, not just for the next 10 or 20 years, but for generations to come. We recognize the importance 
                of establishing a foundation built on transparency, trust, and respect.<br/><br/>
                We embrace a set of core values that reflect our commitment to the highest ethical standards:
                </>
              ):(
                <>
                En <b>BALGOD</b>, estamos impulsados por un fuerte sentido de responsabilidad hacia nuestros socios, empleados 
                y el medio ambiente. Nuestra misión es crear una familia financiera—una red unida y solidaria de miembros 
                y socios que prosperarán juntos, no solo durante los próximos 10 o 20 años, sino por generaciones. Reconocemos 
                la importancia de establecer una base construida sobre la transparencia, la confianza y el respeto.<br/><br/>
                Adoptamos un conjunto de valores fundamentales que reflejan nuestro compromiso con los más altos estándares éticos:
                </>
              )}
</Text>

        </Box>
      </Flex>

      <Flex
        w="100%"
        justify="space-around"
        wrap="wrap"
        px={8}
        pt={10}
        pb={10}
        direction={{ base: "column", lg: "row" }}
        backgroundColor="black" // Set the background color to black for the whole Flex container
      >

        <Box
          flex="1"
          p={4}
          mx={{ base: 0, md: 2 }}
          textAlign="center"
          mb={{ base: 4, lg: 0 }}
          w={{ base: "100%", lg: "25%" }}
          backgroundColor={"black"}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Text
            fontSize={{ base: 20, lg: 30 }}
            color={"white"}
            minH="100px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            {isEnglish ? "Transparency and Integrity" : "Transparencia e Integridad"}
          </Text>
          <Image
            src={integrity01}
            className="hover-image"
            width="40%"
            borderRadius="1rem"
            mt={4}
            pb={4}
            id="image01"
          />
          <Text fontSize={18} color={"white"} pb={4}>
            {isEnglish ? (
              <>
              We operate with full honesty and openness in all 
              our dealings, ensuring clear communication and fair practices at every stage of our operations.
              </>
            ):(
              <>
              Operamos con total honestidad y apertura en todas nuestras transacciones, 
              asegurando una comunicación clara y prácticas justas en cada etapa de nuestras operaciones.
              </>
            )}
            </Text>
        </Box>

        <Box
          flex="1"
          p={4}
          mx={{ base: 0, md: 2 }}
          textAlign="center"
          mb={{ base: 4, lg: 0 }}
          w={{ base: "100%", lg: "25%" }}
          backgroundColor={"black"}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Text
            fontSize={{ base: 20, lg: 30 }}
            color={"white"}
            minH="100px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            {isEnglish ? "Community and Employee Welfare" : "Bienestar Comunitario y Laboral"}
          </Text>
            
          <Image
            src={community01}
            className="hover-image"
            width="40%"
            borderRadius="1rem"
            mt={4}
            pb={18}
            id="image02"
          />
          <Text fontSize={18} color={"white"} pb={4}>
            {isEnglish ? (
              <>
              We are deeply committed to the well-being of the communities 
              surrounding our mining operations. This includes creating local employment opportunities, offering 
              competitive benefits, and investing in the overall prosperity of the area. The safety and security 
              of our team members are paramount, and we ensure that all projects meet the highest safety standards.
              </>
            ): (
              <>
              Estamos profundamente comprometidos con el bienestar de las comunidades 
              que rodean nuestras operaciones mineras. Esto incluye la creación de 
              oportunidades laborales locales, ofreciendo beneficios competitivos e 
              invirtiendo en la prosperidad general de la zona. La seguridad y el 
              bienestar de nuestros colaboradores son primordiales, y garantizamos 
              que todos nuestros proyectos cumplan con los más altos estándares de seguridad.
              </>
            )}
            </Text>
        </Box>

        <Box
          flex="1"
          p={4}
          mx={{ base: 0, md: 2 }}
          textAlign="center"
          mb={{ base: 4, lg: 0 }}
          w={{ base: "100%", lg: "25%" }}
          backgroundColor={"black"}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Text
            fontSize={{ base: 20, lg: 30 }}
            color={"white"}
            minH="100px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            {isEnglish ? "Environmental Responsibility": "Responsabilidad Ambiental"}
            </Text>
          <Image
            src={environmental01}
            className="hover-image"
            id="image03"
            width="40%"
            borderRadius="1rem"
            mt={4}
            pb={4}
          />
          <Text fontSize={18} color={"white"} pb={4}>
            {isEnglish ? (
              <>
              We prioritize environmental sustainability. We are pioneers 
              in reducing the ecological impact of mining through innovative practices, such as water filtration 
              and reuse systems, and our commitment to reforestation ensures that the ecosystems affected by our 
              projects are restored for future generations.
              </>
            ):(
              <>
              Nosotros priorizamos la sostenibilidad ambiental. Somos pioneros 
              en reducir el impacto ecológico de la minería mediante prácticas innovadoras, 
              como sistemas de filtración y reutilización del agua, y nuestro compromiso 
              con la reforestación asegura que los ecosistemas afectados por nuestros proyectos 
              sean restaurados para las generaciones futuras.
              </>
            )}
            </Text>
        </Box>

        <Box
          flex="1"
          p={4}
          mx={{ base: 0, md: 2 }}
          textAlign="center"
          mb={{ base: 4, lg: 0 }}
          w={{ base: "100%", lg: "25%" }}
          backgroundColor={"black"}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Text
            fontSize={{ base: 20, lg: 30 }}
            color={"white"}
            minH="100px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            {isEnglish ? "Safety and Risk Management" : "Seguridad y Gestión de Riesgos"}
            </Text>
          <Image
            src={safety01}
            className="hover-image"
            id="image04"
            width="40%"
            borderRadius="1rem"
            mt={4}
            pb={4}
          />
          <Text fontSize={18} color={"white"} pb={4}>
            {isEnglish ? (
              <>
              We have implemented rigorous safety protocols across
              all our operations, ensuring that both human and animal life is 
              safeguarded. Safety is our absolute priority.
              </>
            ):(
              <>
              Hemos implementado rigurosos protocolos de seguridad 
              en todas nuestras operaciones, garantizando que tanto la 
              vida humana como animal estén protegidas. La seguridad es 
              nuestra absoluta prioridad.
              </>
            )}

            </Text>
        </Box>
      </Flex>

      {/* Add your CSS styles */}
      <style jsx>{`
  .hover-image {
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  #image01:hover {
    content: url(${integrity02}); /* Adjust for each image */
    transform: scale(1.05);
  }

  #image02:hover {
    content: url(${community02}); /* Adjust for each image */
    transform: scale(1.05);
  }

  #image03:hover {
    content: url(${environmental02}); /* Adjust for each image */
    transform: scale(1.05);
  }

  #image04:hover {
    content: url(${safety02}); /* Adjust for each image */
    transform: scale(1.05);
  }
`}</style>


      <Flex
        w="100%"
        justify="center"
        alignItems="center"
        wrap="wrap"
        mt={14}
        px={8}
        direction={{ base: "column", lg: "row" }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          p={4}
          mx={{ base: 0, md: 2 }}
          textAlign="center"
          mb={{ base: 4, lg: 0 }}
          w={{ base: "100%", lg: "80%" }}
          maxWidth="900px"
          backgroundColor={"black"}
        >
          <iframe
            style={{
              width: "100%",
              height: "auto",
              aspectRatio: "16/9",
              maxWidth: "100%",
              border: "none"
            }}
            src="https://www.youtube.com/embed/HoGCPst8KZU?si=TGf5OWhSIhe5918S"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </Box>
        </Flex>

      <Flex w="100%" justify="space-around" mt={8} px={8} mb={16}>
        <Box w="100%" maxW="90%" flex="1" p={4} mx={0} textAlign="center">
          <Text fontSize={{ base: 24, lg: 40 }}>
            {isEnglish? "This is How it Works" : "Así Es Como Funciona"}
          </Text>
          <Text fontSize={{ base: 18, lg: 20 }} color={"#444"} lineHeight={"2.0"} mt={5} textAlign="justify">
            {isEnglish ? (<>
              At <b>BALGOD</b>, we are not just changing the 
              way mining operations are conducted; we are setting a new standard for the industry. By cutting out the 
              middlemen and establishing direct, transparent partnerships with mine owners, we ensure that every step 
              of the process is optimized for fairness and efficiency. Our team of experts, from specialists in mining 
              to international security and global sales, works together to provide solutions that meet the complex 
              demands of modern resource extraction. With <b>BALGOD</b>, you can trust that your operations will run smoothly, 
              ethically, and with a focus on long-term sustainability.
            </>
            ):(<>
              En <b>BALGOD</b>, no solo estamos cambiando la forma en que se llevan a cabo las operaciones mineras; 
              estamos estableciendo un nuevo estándar para la industria. Al eliminar intermediarios y establecer 
              asociaciones directas y transparentes con los propietarios de minas, garantizamos que cada paso del proceso 
              esté optimizado para lograr equidad y eficiencia. Nuestro equipo de expertos, desde especialistas en minería 
              hasta seguridad internacional y ventas globales, trabajan en conjunto para ofrecer soluciones que respondan 
              a las demandas complejas y modernas de la extracción de recursos. Con <b>BALGOD</b>, puedes confiar que tus 
              operaciones funcionarán de manera fluida, ética y con un enfoque en la sostenibilidad a largo plazo.
            </>
            )  
          } </Text>
            
          <Text fontSize={{ base: 18, lg: 20 }} color={"#444"} lineHeight={"2.0"} mt={5} textAlign="justify">
            {isEnglish? (<>
              We understand that the 
              mining industry can be complex, and navigating through it with outdated models can slow progress. 
              That's why we are dedicated to providing cutting-edge, sustainable solutions that streamline the 
              entire process—from extraction to market. When you partner with <b>BALGOD</b>, you gain more than just 
              a service; you gain a trusted ally in the mining sector who is committed to transparency, 
              innovation, and mutual success. Together, we can achieve not only better financial outcomes 
              but also create a lasting impact on the communities and environments where we operate. Let's 
              build a future that works for everyone, today and for generations to come.
            </>):(<>
              Entendemos que la 
              industria minera puede ser compleja, y que avanzar con modelos obsoletos puede retrasar el progreso. 
              Por eso, nos dedicamos a ofrecer soluciones sostenibles y de vanguardia que agilicen todo el 
              proceso, desde la extracción hasta el mercado. Cuando te asocias con <b>BALGOD</b>, obtienes más que un 
              servicio; obtienes un aliado confiable en el sector minero, comprometido con la transparencia, 
              la innovación y el éxito mutuo. Juntos, podemos lograr no solo mejores resultados financieros, 
              sino también crear un impacto duradero en las comunidades y entornos donde operamos. 
              Construyamos un futuro que funcione para todos, hoy y para las generaciones futuras.
            </>)}
          </Text>
        </Box>
      </Flex>

      <Flex
        w="100%"
        justify="center"
        alignItems="center"
        wrap="wrap"
        mt={4}
        px={8}
        mb={14}
        direction={{ base: "column", lg: "row" }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          p={4}
          mx={{ base: 0, md: 2 }}
          textAlign="center"
          mb={{ base: 4, lg: 0 }}
          w={{ base: "100%", lg: "80%" }}
          maxWidth="900px"
          backgroundColor={"black"}
        >
          <iframe
            style={{
              width: "100%",
              height: "auto",
              aspectRatio: "16/9",
              maxWidth: "100%",
              border: "none"
            }}
            src="https://www.youtube.com/embed/hKIhjvXLnrU?si=jUxZyJgFBWowEQxE"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </Box>
        </Flex>

      <Flex
        w="100%"
        justify="space-around"
        wrap="wrap"
        mt={8}
        px={8}
        pt={10}
        pb={10}
        direction={{ base: "column", lg: "row" }}
        backgroundColor="cyan.50" // Set the background color to black for the whole Flex container
      >
        <Box  w="100%" maxW="90%" flex="1" p={4} mx={0}>
          <Text fontSize={{ base: 24, lg: 40 }} textAlign="center">
            {isEnglish ? "Company Overview" : "Visión General de la Empresa"}
            </Text>
          <Image src={divider} width="50px" mx="auto" mt={5}/>
          <Text fontSize={{ base: 18, lg: 20 }} color={"#444"} lineHeight={"2.0"} mt={5} textAlign="justify">
            {isEnglish ? (
              <>
              Established in 2023, <b>BALGOD</b> is  
              not just another mining company; it represents a transformative movement aimed at 
              reshaping the industry with a focus on ethics, transparency, and sustainability. Our team is 
              composed of professionals from diverse backgrounds, all united by a common goal: to reform 
              the mining sector and eliminate the inefficiencies and injustices caused by traditional 
              intermediaries. We are actively forging strategic partnerships with mine owners across the 
              Americas and have ambitious plans to expand into key regions of North, Central, and South America.  
              </>
            ) : (
              <>
              Fundada en 2023, <b>BALGOD</b> no es solo otra empresa minera; representa 
              un movimiento transformador con el objetivo de reformar la industria con un 
              enfoque en la ética, la transparencia y la sostenibilidad. Nuestro equipo 
              está compuesto por profesionales de diversos orígenes, todos unidos por un 
              objetivo común: reformar el sector minero y eliminar las ineficiencias e 
              injusticias causadas por los intermediarios tradicionales. Actualmente 
              estamos estableciendo asociaciones estratégicas con propietarios de minas a 
              lo largo de las Américas y tenemos planes ambiciosos para expandirnos hacia 
              regiones clave de América del Norte, Central y del Sur.
              </>
            )}
            </Text>
            <Text fontSize={{ base: 18, lg: 20 }} color={"#444"} lineHeight={"2.0"} mt={5} textAlign="justify">
              {isEnglish ? (
                <>
                Looking ahead, our dedication to responsible growth and positive impact 
                remains steadfast. <b>BALGOD</b> is committed to building a company that not 
                only thrives in the long term but also creates lasting value for the mining 
                industry, the environment, and the communities we serve.    
                </>
              ):(
                <>
                Mirando hacia el futuro, nuestra dedicación al crecimiento responsable y 
                al impacto positivo sigue siendo firme. <b>BALGOD</b> se compromete a construir 
                una empresa que no solo prospere a largo plazo, sino que también genere valor 
                duradero para la industria minera, el medio ambiente y las comunidades a las que servimos.
                </>
              )}
            </Text>
            <Image src={partners} width={"70%"} mt={16} mx="auto"/>

        </Box>
      </Flex>
    </>
  )
}


MainPage.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
}